export const firebaseConfig = {
  apiKey: "AIzaSyDCdX8uUUK9kwcaqSXumjillruROTFEuuk",
  authDomain: "newro-dev.firebaseapp.com",
  projectId: "newro-dev",
  storageBucket: "newro-dev.firebasestorage.app",
  messagingSenderId: "161138896461",
  appId: "1:161138896461:web:3f1fdb8de487331caf3604",
  measurementId: "G-EPSVGDZKWZ"
};